import { ProjectType } from '@/types/project';
import rem from '@/utils/rem';
import { Checkbox, Flex, Text } from '@chakra-ui/react';

type Props = {
  projects: ProjectType[];
  selectedProjects: string[];
  onToggle: (projectId: string) => void;
};

const ProjectSelector = ({ projects, selectedProjects, onToggle }: Props) => {
  return (
    <Flex
      flexDirection="column"
      gap={rem(10)}
      overflow="auto"
      width="full"
      maxHeight={rem(500)}
      marginTop={rem(20)}
      padding={rem(10)}
      borderRadius="base "
      backgroundColor="background-primary"
    >
      {projects.map((p) => (
        <Flex
          key={p.id}
          alignItems="center"
          justifyContent="space-between"
          borderRadius="base"
          backgroundColor="background-tertiary"
          paddingX={rem(10)}
          paddingY={rem(4)}
        >
          <Text textStyle="projectSelectorRowTitle" color="text-primary">
            {p.name}
          </Text>
          <Checkbox isChecked={selectedProjects.includes(p.id)} onChange={() => onToggle?.(p.id)} />
        </Flex>
      ))}
    </Flex>
  );
};

export default ProjectSelector;
